"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@/react-app/common/components/Button"));
function TablePageHeader(_a) {
    var title = _a.title, newButtonLabel = _a.newButtonLabel, href = _a.href, dataCy = _a.dataCy;
    return (react_1.default.createElement("div", { className: "row content" },
        react_1.default.createElement("div", { className: "col-md-6" },
            react_1.default.createElement("h3", { className: "page-title" }, title)),
        react_1.default.createElement("div", { className: "col-md-6" },
            react_1.default.createElement("span", { className: "pull-right" },
                react_1.default.createElement("a", { href: href, id: "link-create-list", "data-cy": dataCy },
                    react_1.default.createElement(Button_1.default, { text: newButtonLabel }))))));
}
exports.default = TablePageHeader;
